import { http } from '@pendo/http';

export async function fetchSurveys () {
    return http.get('api/s/_SID_/survey').then((res) => res.data);
}

export async function fetchSurvey (id) {
    return http.get(`api/s/_SID_/survey/${id}`).then((res) => res.data);
}

export async function createSurveyFromTemplate ({ payload }) {
    return http.post('api/s/_SID_/survey/templated', payload).then((res) => res.data);
}

export async function updateSurveyRecurrence ({ id, recurrence }) {
    return http.put(`api/s/_SID_/survey/${id}/recurrence`, recurrence).then((res) => res.data);
}

export async function updateSurveyStatus ({ id, status }) {
    return http.put(`api/s/_SID_/survey/${id}/status/${status}`, {}).then((res) => res.data);
}

export async function updateSurveyDetails ({ id, payload }) {
    return http.put(`api/s/_SID_/survey/${id}`, payload).then((res) => res.data);
}

export function fetchSurveyResponseSummary ({ surveyId, timeSeries, segmentId, includeAnonymous, accountId, refresh }) {
    const { first, count, period } = timeSeries.spec;

    return http
        .post(`api/s/_SID_/survey/${surveyId}/summarize`, { first, count, period, segmentId, includeAnonymous, accountId, refresh })
        .then((res) => res.data);
}

export async function updateSurveyDelivery ({ id, audienceConfig, deliveryId }) {
    return http.put(`api/s/_SID_/survey/${id}/delivery/${deliveryId}`, audienceConfig).then((res) => res.data);
}

export async function updateSurveyDeliveryItems ({ id, deliveryId, deliveryConfig }) {
    return http.put(`api/s/_SID_/survey/${id}/delivery/${deliveryId}/items`, deliveryConfig).then((res) => res.data);
}

export async function upsertSurveyEmailDelivery ({ id, payload }) {
    return http.put(`api/s/_SID_/survey/${id}/emailDelivery`, payload).then((res) => res.data);
}

export async function fetchSurveyEmailTemplatePreview () {
    return http.get('api/s/_SID_/survey/emailTemplate/preview').then((res) => res.data);
}

export async function deleteSurvey (id) {
    return http.delete(`api/s/_SID_/survey/${id}`);
}

export async function cloneSurvey ({ surveyId, targetAppId }) {

    return http.post(`api/s/_SID_/survey/${surveyId}/clone`, { targetAppId }).then((res) => res.data);
}

export async function fetchSurveyItems (surveyId) {
    return http.get(`api/s/_SID_/survey/${surveyId}/items`).then((res) => res.data);
}

export async function fetchSurveySlackChannels (surveyId) {
    return http.get(`api/s/_SID_/survey/${surveyId}/slack-channels`).then((res) => res.data?.slackChannels ?? []);
}

export async function updateSurveySlackChannels ({ surveyId, slackChannels }) {
    return http
        .put(`api/s/_SID_/survey/${surveyId}/slack-channels`, { slackChannels })
        .then((res) => res.data?.slackChannels ?? []);
}
